import { InvoiceStatusEnum } from "@altertec_gparn/lib";
import { Expose } from "class-transformer";

export class ChangeInvoiceStatusDto {
  @Expose()
  id: string;

  @Expose()
  status: InvoiceStatusEnum;
}
